export const SYSTEM_UPDATE = 'SYSTEM_UPDATE';
export const PARTICLE_CREATED = 'PARTICLE_CREATED';
export const PARTICLE_UPDATE = 'PARTICLE_UPDATE';
export const PARTICLE_DEAD = 'PARTICLE_DEAD';
export const EMITTER_ADDED = 'EMITTER_ADDED';
export const EMITTER_REMOVED = 'EMITTER_REMOVED';
export const EMITTER_DEAD = 'EMITTER_DEAD';
export const SYSTEM_UPDATE_AFTER = 'SYSTEM_UPDATE_AFTER';
